import { createContext } from "react";
import { CustomerDetails } from "./courses.types";

const CustomerContext = createContext<CustomerDetails | null>(null);

export default CustomerContext;
